import { useAuth0 } from '@auth0/auth0-react';
import { Box, Typography } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import { redirectUri_logout } from '../../config';
import { routes } from '../../routes';
import { canUserAccess } from '../../utils/userAuthorization';
import { Colors } from '../../constants/theme';
import Dropdown from '../atoms/dropdown/dropdown';
import WorkshopSelector from './workshopSelector';

const NAVBAR_HEIGHT = 56;

const navLinkStyles = {
  display: 'block',
  padding: '8px 16px',
  textTransform: 'uppercase',
  fontWeight: 400,
  fontSize: 18,
  color: 'white',
  textDecoration: 'underline',
  textDecorationColor: 'transparent',
  '&:hover': {
    textDecorationColor: 'white',
  },
} as const;

const Navbar = () => {
  const { user, logout } = useAuth0();
  const location = useLocation();

  if (!user) {
    return null;
  }

  const navbarRoutes = routes.filter(
    route => route.navbar && canUserAccess(user.sub, route.allowedUserIds)
  );
  const activePath = location.pathname.split('/')[1] || '';

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: redirectUri_logout(),
      },
    });
  };

  return (
    <Box
      component="nav"
      sx={{
        position: 'fixed',
        top: 0,
        width: '100%',
        height: NAVBAR_HEIGHT,
        backgroundColor: '#000',
        zIndex: 30,
        boxShadow: '4px -10px 7px 15px rgba(0,0,0,0.1)'
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 0.5
        }}
      >
        <Box sx={{ display: 'flex', width: '45%', }}>
          {navbarRoutes.map(route => {
            const routePath = route.url.split('/')[1] || '';
            const isSelected = routePath === activePath || (route.url === '/' && location.pathname === '/');

            return (
              <Box key={route.url}>
                <NavLink
                  to={route.navbarUrl ?? route.url}
                  style={{ textDecoration: 'none' }}
                >
                  <Box
                    component="span"
                    sx={{
                      ...navLinkStyles,
                      color: isSelected ? Colors.light.green : 'white',
                      textDecorationColor: isSelected ? Colors.light.green : 'transparent',
                      '&:hover': {
                        textDecorationColor: isSelected ? Colors.light.green : 'white',
                      },
                    }}
                  >
                    {route.name}
                  </Box>
                </NavLink>
              </Box>
            );
          })}
        </Box>

        <Typography
          sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            margin: '0 auto',
            width: 'fit-content',
            color: 'white',
            fontSize: 14,
            fontWeight: 500,
            letterSpacing: 1,
            textTransform: 'uppercase',
            pointerEvents: 'none',
          }}
        >
          Van Check
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '45%',
            height: '100%',
            paddingRight: '16px',
            gap: '32px',
          }}
        >
          <WorkshopSelector />
          <Dropdown
            title={user.name ?? ''}
            data={[{ label: 'Logout', onClick: handleLogout }]}
          />
        </Box>
      </Box>
    </Box>
  );
};

export const navbarHeight = NAVBAR_HEIGHT;
export default Navbar;
